import { Component, inject } from '@angular/core';
import { ITipoListadoCategoria } from 'modelos/src';
import { PermisosEntidadesService } from '../../../../auxiliares/servicios/http/permisos-entidades.service';

@Component({
  selector: 'app-listado-categorias-eventos-tecnicos',
  templateUrl: './categorias-eventos-tecnicos.component.html',
  styleUrl: './categorias-eventos-tecnicos.component.scss',
  standalone: false,
})
export class ListadoCategoriasEventosTecnicosComponent {
  private permisos = inject(PermisosEntidadesService);

  /** Categorías de servicio técnico filtradas por las entidades visibles del cliente */
  public categorias: ITipoListadoCategoria[] = this.categoriasHabilitadas();

  private categoriasHabilitadas(): ITipoListadoCategoria[] {
    const cats: ITipoListadoCategoria[] = [];
    if (this.permisos.verTrackers()) {
      cats.push('Evento-Tecnico-Tracker');
    }
    if (this.permisos.verModuloAlarmas()) {
      cats.push('Evento-Tecnico-Alarma');
    }
    if (this.permisos.verModuloVehiculos()) {
      cats.push('Evento-Tecnico-Vehiculo');
    }
    if (this.permisos.verModuloLuminarias()) {
      cats.push('Evento-Tecnico-Luminaria');
    }
    if (this.permisos.verGateways()) {
      cats.push('Evento-Tecnico-Gateway');
    }
    if (this.permisos.verModuloSirenas()) {
      cats.push('Evento-Tecnico-Sirena');
    }
    return cats;
  }
}
